import React, { useState } from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { toast } from 'sonner';
import type { CitizenSession } from './CitizenApp';
import { OWNER_USER } from '../../data/users';
import { MEDIA } from '../../data/media';
import { useStore } from '../../contexts/StoreContext';
import { DmpLogo } from '../../components/brand/DmpLogo';
import { BdFlag } from '../../components/brand/BdFlag';
import { bn, maskMobile } from '../../utils/bn';
type Tab = 'otp' | 'password' | 'pcr' | 'register';
export function CitizenLogin({
  onLogin,
  onExit
}: {
  onLogin: (s: CitizenSession) => void;
  onExit: () => void;
}) {
  const {
    getCase
  } = useStore();
  const [tab, setTab] = useState<Tab>('otp');
  const [mobile, setMobile] = useState(OWNER_USER.mobile);
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState('');
  const [pw, setPw] = useState('');
  const [pcr, setPcr] = useState('PCR-2026-00421');
  const [reg, setReg] = useState({
    name: '',
    mobile: '',
    nid: '',
    address: '',
    password: ''
  });
  const [error, setError] = useState('');
  const sendOtp = () => {
    if (!/^01[3-9]\d{8}$/.test(mobile)) {
      setError('সঠিক ১১ সংখ্যার মোবাইল নম্বর দিন।');
      return;
    }
    setError('');
    setOtpSent(true);
    toast.info(`${maskMobile(mobile)} নম্বরে OTP পাঠানো হয়েছে। ডেমো OTP: ১২৩৪৫৬`);
  };
  const verify = (afterPcr?: string) => {
    if (otp !== '123456' && otp !== '১২৩৪৫৬') {
      setError('OTP সঠিক নয়। ডেমো OTP: ১২৩৪৫৬');
      return;
    }
    if (afterPcr) {
      const c = getCase(afterPcr.trim().toUpperCase());
      if (!c) {
        setError('এই PCR নম্বরটি পাওয়া যায়নি।');
        return;
      }
      if (c.mobile !== mobile) {
        setError('মোবাইল নম্বরটি এই PCR-এর নিবন্ধিত নম্বরের সাথে মেলেনি।');
        return;
      }
      onLogin({
        name: c.ownerName,
        mobile,
        guestPcr: c.pcr
      });
      return;
    }
    onLogin({
      name: OWNER_USER.name,
      mobile
    });
  };
  const TABS: {
    id: Tab;
    label: string;
  }[] = [{
    id: 'otp',
    label: 'মোবাইল ও OTP'
  }, {
    id: 'password',
    label: 'পাসওয়ার্ড'
  }, {
    id: 'pcr',
    label: 'PCR দিয়ে'
  }, {
    id: 'register',
    label: 'নিবন্ধন'
  }];
  const otpBlock = (pcrMode = false) => <>
      <div data-id="element-1603" data-mp="2vpqxknk3dpv2">
        <label className="label" htmlFor="cm" data-id="element-1604" data-mp="2vqaec0y0a87i">মোবাইল নম্বর</label>
        <input id="cm" className="input" inputMode="numeric" value={mobile} onChange={e => setMobile(e.target.value.replace(/\D/g, '').slice(0, 11))} data-id="element-1605" data-mp="39p0ddm4dyhyi" />
      </div>
      {otpSent && <div data-id="element-1606" data-mp="3jld2e6ozk7mx">
          <label className="label" htmlFor="otp" data-id="element-1607" data-mp="3jktvrm4sd5o7">OTP কোড</label>
          <input id="otp" className="input text-center text-lg tracking-[0.5em]" maxLength={6} value={otp} onChange={e => setOtp(e.target.value)} placeholder="••••••" data-id="element-1608" data-mp="3enbnlxyleuh9" />
          <p className="mt-1 text-[11px] text-ink-soft" data-id="element-1609" data-mp="3tdr6v77g7scs">ডেমো OTP: {bn('123456')} — কোনো প্রকৃত SMS পাঠানো হয়নি</p>
        </div>}
      <button className="btn btn-primary btn-lg w-full" onClick={() => otpSent ? verify(pcrMode ? pcr : undefined) : sendOtp()} data-id="element-1610" data-mp="66p66yrzhnpz">{otpSent ? 'যাচাই করে প্রবেশ' : 'OTP পাঠান'}</button>
    </>;
  return <div className="flex flex-1 flex-col overflow-y-auto bg-canvas" data-id="element-1611" data-mp="ktntchjt5vyw">
      <div className="relative" data-id="element-1612" data-mp="pt0emxv16uzd">
        <img src={MEDIA.car} alt="" className="h-44 w-full object-cover" data-id="element-1613" data-mp="pta50mjzn45l" />
        <div className="absolute inset-0 bg-navy/80" data-id="element-1614" data-mp="btiwv2g5khzi" />
        <div className="absolute inset-0 flex flex-col px-5 pt-3 text-white" data-id="element-1615" data-mp="bszfbmuezvm0">
          <div className="flex items-center justify-between" data-id="element-1616" data-mp="ftjcgqezmz85">
            <button onClick={onExit} className="lg:hidden flex items-center gap-1 text-xs text-white/80" data-id="element-1617" data-mp="23plo2jxa4vs"><ArrowLeftIcon className="h-4 w-4" data-id="element-1618" data-mp="6u63rzyoueoh" /> ডেমো হোম</button>
            <span data-id="element-1619" data-mp="6vh4ts0r18bw" />
            <BdFlag width={26} data-id="element-1620" data-mp="6vzbzjoy96yl" />
          </div>
          <div className="mt-3 flex items-center gap-3" data-id="element-1621" data-mp="3obp7f8fvc2xi">
            <DmpLogo size={56} tone="light" data-id="element-1622" data-mp="3t9qrnwp168ak" />
            <div data-id="element-1623" data-mp="3taimh5at01zs">
              <h1 className="text-xl font-bold" data-id="element-1624" data-mp="3ta0itnltalhu">ডিএমপি যানবাহন সেবা</h1>
              <p className="text-xs text-white/85 leading-snug" data-id="element-1625" data-mp="3fb0vcja1ccn9">আটককৃত যানবাহনের তথ্য, জরিমানা ও অবমুক্তি সেবা</p>
            </div>
          </div>
        </div>
      </div>
      <div className="-mt-6 mx-4 card p-4 mb-6" data-id="element-1626" data-mp="3c83d7wk2sn9a">
        <div className="mb-4 grid grid-cols-4 gap-1 rounded-lg bg-canvas p-1" data-id="element-1627" data-mp="3c7v2aa7ijs0q">
          {TABS.map(t => <button key={t.id} onClick={() => {
          setTab(t.id);
          setError('');
          setOtpSent(false);
          setOtp('');
        }} className={`rounded-md py-1.5 text-[11px] font-semibold ${tab === t.id ? 'bg-white text-navy shadow-card' : 'text-ink-muted'}`} data-id="element-1628" data-mp="37a1s7633adv6">{t.label}</button>)}
        </div>
        <div className="space-y-3" data-id="element-1629" data-mp="2tjga3jlgm7yc">
          {tab === 'otp' && otpBlock()}
          {tab === 'password' && <>
              <div data-id="element-1630" data-mp="2ol511b2zo1h6"><label className="label" htmlFor="pm" data-id="element-1631" data-mp="2ol4xj13s5jcf">মোবাইল নম্বর</label><input id="pm" className="input" value={mobile} onChange={e => setMobile(e.target.value)} data-id="element-1632" data-mp="2jkgzvwl1q498" /></div>
              <div data-id="element-1633" data-mp="2fjx2crwk8ymk"><label className="label" htmlFor="pp" data-id="element-1634" data-mp="2fjx1yqsnewm1">পাসওয়ার্ড</label><input id="pp" type="password" className="input" value={pw} onChange={e => setPw(e.target.value)} placeholder="ডেমো: যেকোনো পাসওয়ার্ড" data-id="element-1635" data-mp="hsm28kvmk0a0" /></div>
              <button className="btn btn-primary btn-lg w-full" onClick={() => pw ? onLogin({
            name: OWNER_USER.name,
            mobile
          }) : setError('পাসওয়ার্ড লিখুন।')} data-id="element-1636" data-mp="dowh65e5s0tq">লগইন</button>
            </>}
          {tab === 'pcr' && <>
              <div data-id="element-1637" data-mp="25f8a07qvee83"><label className="label" htmlFor="cpcr" data-id="element-1638" data-mp="25f8dihq2wwcu">PCR নম্বর</label><input id="cpcr" className="input font-mono" value={pcr} onChange={e => setPcr(e.target.value)} data-id="element-1639" data-mp="29fr3e68evsce" /></div>
              <p className="text-[11px] text-ink-muted" data-id="element-1640" data-mp="1cq1ap6jldkls">গোপনীয়তার জন্য PCR-এ নিবন্ধিত মোবাইল নম্বরে OTP যাচাই আবশ্যক।</p>
              {otpBlock(true)}
            </>}
          {tab === 'register' && <>
              {([['name', 'নাম'], ['mobile', 'মোবাইল নম্বর'], ['nid', 'জাতীয় পরিচয়পত্র নম্বর (প্রযোজ্য ক্ষেত্রে)'], ['address', 'ঠিকানা'], ['password', 'পাসওয়ার্ড']] as const).map(([k, l]) => <div key={k} data-id="element-1641" data-mp="2x4jvtsptri29"><label className="label" htmlFor={`r-${k}`} data-id="element-1642" data-mp="2x53bf2s05ud4">{l}</label><input id={`r-${k}`} type={k === 'password' ? 'password' : 'text'} className="input" value={reg[k]} onChange={e => setReg({
              ...reg,
              [k]: e.target.value
            })} data-id="element-1643" data-mp="323woiu3dnjcr" /></div>)}
              <button className="btn btn-green btn-lg w-full" onClick={() => {
            if (!reg.name || !/^01[3-9]\d{8}$/.test(reg.mobile) || !reg.password) {
              setError('নাম, সঠিক মোবাইল নম্বর ও পাসওয়ার্ড আবশ্যক।');
              return;
            }
            toast.success('নিবন্ধন সম্পন্ন। OTP দিয়ে মোবাইল নম্বর যাচাই করুন।');
            setMobile(reg.mobile);
            setTab('otp');
            setOtpSent(true);
            setError('');
          }} data-id="element-1644" data-mp="y14n3digocs5">নিবন্ধন করুন</button>
            </>}
          {error && <p className="rounded-md bg-danger-50 px-3 py-2 text-xs text-danger-700" role="alert" data-id="element-1645" data-mp="t1i931ut6sia">{error}</p>}
        </div>
      </div>
    </div>;
}